import { getClassificationFilterIds } from '../../../../classifications/classification-filter.utils';

export const CUSTOMERS_IDS_KEYS = ['customersIdsByData', 'customerIdsByCode'];

export const CUSTOMERS_FILTERS_KEYS = {
  customersIds: 'customersIds',
  [CUSTOMERS_IDS_KEYS[0]]: CUSTOMERS_IDS_KEYS[0],
  [CUSTOMERS_IDS_KEYS[1]]: CUSTOMERS_IDS_KEYS[1],
  classifications: 'classificationIds',
  priceTableIds: 'priceTableIds',
  states: 'states',
  customerGroupIds: 'customerGroupIds',
  cityIds: 'cityIds',
  customerSalesRepresentativeIds: 'customerSalesRepresentativeIds',
  status: 'status',
  integrationStatus: 'synchronized',
  hasMedia: 'hasMedia',
  myNetwork: 'myNetwork',
  query: 'query',
  createdAtStart: 'createdAtStart',
  createdAtEnd: 'createdAtEnd',
  origin: 'origin',
  withoutApprovedOrdersAtStart: 'withoutApprovedOrdersAtStart',
  withoutApprovedOrdersAtEnd: 'withoutApprovedOrdersAtEnd',
  unconvertedCustomers: 'unconvertedCustomers',
};

export const formatSearchParamsCustomerIds = (values: Record<string, any> = {}) => {
  const { classificationIds, newValues } = getClassificationFilterIds(values);
  const cloneValues = { ...newValues };

  const customersIds: string[] = [];
  CUSTOMERS_IDS_KEYS.forEach((key) => {
    const ids = cloneValues[key];
    delete cloneValues[key];
    if (ids) {
      const idsInArray = Array.isArray(ids) ? ids : [ids];
      customersIds.push(...idsInArray);
    }
  });

  return {
    ...cloneValues,
    [CUSTOMERS_FILTERS_KEYS.customersIds]: customersIds.length ? customersIds : undefined,
    [CUSTOMERS_FILTERS_KEYS.classifications]: classificationIds.length
      ? classificationIds
      : undefined,
  };
};
